import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // Login
  {
    path: '/',
    redirect: {
      path: '/withdraw'
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: () => import('../views/withdraw.vue'),
  },
  {
    path: '/specialevent',
    name: 'specialevent',
    component: () => import('../views/specialevent.vue')
  },
  {
    path: '/category',
    name: 'category',
    component: () => import('../views/category.vue')
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('../views/company/company.vue')
  },
  {
    path: '/company/detail',
    name: 'company_detail',
    component: () => import('../views/company/detail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router